import * as React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Button, FormGroup, InputGroup, Icon } from "@blueprintjs/core";
import { Spacer } from "components/common";
import { useControlledInput } from "../../hooks";
import { useAuthActions } from "context/";
import { withPreventDefault, validatePassword } from "utils";
import Error from "./Error";
import PasswordRequirements from "./PasswordRequirements";
import { css } from "@emotion/core";

const notEmpty = (v) => v !== "";

const AcceptInvite = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { passwordReset } = useAuthActions();

  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const {
    valid: $email,
    reset: resetEmail,
    ...email
  } = useControlledInput(notEmpty);

  const {
    valid: $code,
    reset: resetCode,
    ...code
  } = useControlledInput(notEmpty);

  const {
    valid: $password,
    reset: resetPassword,
    ...password
  } = useControlledInput(validatePassword);

  const {
    valid: $confirmation,
    reset: resetConfirmation,
    ...confirmation
  } = useControlledInput((v) => $password && v === password.value);

  if (props.currentUser) {
    return <Navigate to="/folders" />;
  }

  React.useEffect(() => {
    const query = new URLSearchParams(location.search);
    const searchEmail = query.get("email");
    const searchCode = query.get("code");

    if (searchEmail) {
      email.onChange({ target: { value: searchEmail } });
    }

    if (searchCode) {
      code.onChange({ target: { value: searchCode } });
    }
  }, [location.search]);

  const valid = $email && $code && $password && $confirmation;

  return (
    <form
      onSubmit={withPreventDefault((event) => {
        setLoading(true);
        passwordReset(email.value, code.value, password.value).then(
          (result) => {
            if (result !== true) {
              setLoading(false);
              setError(result);
            }
          }
        );
      })}
    >
      <FormGroup label="Login Email" labelFor="email-input">
        <InputGroup
          id="email-input"
          placeholder="Login Email"
          disabled
          {...email}
        />
      </FormGroup>

      <input type="hidden" id="code-input" {...code} />

      <FormGroup label="Password" labelFor="password-input">
        <InputGroup
          id="password-input"
          type="password"
          placeholder="Password"
          autoFocus
          {...password}
        />
        <PasswordRequirements password={password.value} />
      </FormGroup>
      <FormGroup label="Password Confirmation" labelFor="confirmation-input">
        <InputGroup
          id="confirmation-input"
          type="password"
          placeholder="Password Confirmation"
          {...confirmation}
          rightElement={
            $confirmation ? (
              <div
                css={css`
                  height: 30px;
                  width: 32px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                `}
              >
                <Icon icon="tick" intent="success" />
              </div>
            ) : undefined
          }
        />
      </FormGroup>
      <Error message={error} />
      <Button
        intent="primary"
        fill
        disabled={valid == false}
        type="submit"
        loading={loading}
      >
        Set Password & Accept Invitation
      </Button>
      {error && (
        <>
          <Spacer />
          <Button
            intent="primary"
            fill
            type="button"
            onClick={() => navigate("/login")}
          >
            Login
          </Button>
        </>
      )}
    </form>
  );
};

export default AcceptInvite;
